/**
 * Same {error:[{field,messages}]} shape as SettingsPage/errorHelpers.js
 * (AppExceptionRenderer.php). Upload errors are keyed under "file" by
 * UploadFileForm's validator; org edit errors are keyed by settings field.
 */
export function parseFieldError(error, field) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];
  const entry = entries.find((e) => e.field === field);
  return entry?.messages?.[0] || null;
}

export function parseGeneralError(error, fallback) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];
  const messages = entries.flatMap((entry) => entry.messages || []);

  if (messages.length) {
    return messages.join(" ");
  }

  return data?.message || error?.message || fallback;
}
